<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData= $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";


import WorkScheduleGroupForm from "../../../components/attendance/workschedulegroup/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": WorkScheduleGroupForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('attendancerecordsandprocesses.editworkschedulegroupassignment'),
      pageTitleValue: "",
      formData: {
        groupid: null,
        groupcode: null,
        groupdesc: null,
        startdate: null,
        enddate: null,
        shiftid: null,
        shiftdesc: null,
        shiftcode: null,
        //logicscrpt: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {

    errorHandler($event) {
    this.isErr = $event.isErr;
    this.errMsg = $event.errMsg;
    },

    loadWorkScheduleGroupHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/workschedulegroup/" + vm.id})
        .then((res) => {

          if (res.data.rec[0].startdate) {
              vm.formData.startdate = moment(res.data.rec[0].startdate).format(
              "YYYY-MM-DD"
            );
          }

          if (res.data.rec[0].enddate) {
              vm.formData.enddate = moment(res.data.rec[0].enddate).format(
              "YYYY-MM-DD"
            );
          }

          vm.formData.groupid = res.data.rec[0].groupid;
          vm.formData.groupcode = res.data.rec[0].groupcode;
          vm.formData.groupdesc = res.data.rec[0].groupdesc;
          vm.formData.shiftid = res.data.rec[0].shiftid;
          vm.formData.shiftdesc = res.data.rec[0].shiftdesc;
          vm.formData.shiftcode = res.data.rec[0].shiftcode;
          vm.formData.lockstaff = res.data.rec[0].lockstaff;
          vm.formData.stamp = res.data.rec[0].stamp;
          
          vm.pageTitleValue = res.data.rec[0].groupdesc;
          vm.loading = false;

        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },


    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      //var payload = this.formData[0];

      this.$store.dispatch('put', {url: "/workschedulegroup/" + vm.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "workschedulegrouplist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

     cancelHandler() {
       this.$router.push({ name: "workschedulegrouplist", params: { search: this.search}  });
     },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

         this.$store.dispatch('delete', {url:
            "/workschedulegroup/" +
            this.id +
            "/" +
            this.formData.userid
        })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "workschedulegrouplist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "workschedulegroupnew" });
    },
  },

  async mounted() {
    await this.loadWorkScheduleGroupHandler();
  },
};
</script>